import { Caption, Form, Title, Input, Row, Col, Divider, Select, Flex, Checkbox, Button, styled } from '@teko/ds-desktop';
import { LocationOutlined } from '@teko/ds-icon';
import { PATTERN_VALIDATION } from '@teko/utils';
import React, { useState, useEffect } from 'react';
import { t } from '../i18n.es.js';
import { useAddressForm } from '../hooks/useAddressForm.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const COUNT_STRING_WITHOUT_STREET_ADDRESS = 4;
const UpsertAddressForm = ({
  editingAddress,
  locationService,
  locationsLimit,
  requireEmail = false,
  userService,
  form,
  setFormSelectValues,
  onCloseForm,
  platformCode,
  hideFormTitle = false,
  defaultCheckboxJustify = "start",
  children,
  allowAddDefaultAdress,
  dataSuggestion,
  openListSuggestion,
  onChangeAddress,
  customOnProvinceChanged,
  customOnDistrictChanged,
  customOnWardChanged,
  setOpenListSuggestion,
  isLoadingSuggest,
  isDisableFullAddressWhenNotOtherInfo,
  getPlaceDetails
}) => {
  const {
    provinces = [],
    districts = [],
    wards = [],
    province,
    district,
    ward,
    onProvinceChanged,
    onDistrictChanged,
    onWardChanged,
    initialFormValues,
    submitForm,
    message,
    setPlace,
    setLocation
  } = useAddressForm({
    editingAddress,
    locationsLimit,
    locationService,
    userService,
    requireEmail,
    platformCode,
    allowAddDefaultAdress
  });
  const [isDefault, setIsDefault] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  useEffect(() => {
    if (!!province && !!district && !!ward && setFormSelectValues) {
      const { code: provinceCode, name: provinceName } = province;
      const { code: districtCode, name: districtName } = district;
      const { code: wardCode, name: wardName } = ward;
      customOnProvinceChanged == null ? void 0 : customOnProvinceChanged(province);
      customOnDistrictChanged == null ? void 0 : customOnDistrictChanged(district);
      customOnWardChanged == null ? void 0 : customOnWardChanged(ward);
      setFormSelectValues({
        provinceCode,
        provinceName,
        districtCode,
        districtName,
        wardCode,
        wardName
      });
    }
  }, [province, district, ward]);
  useEffect(() => {
    form.resetFields();
    if (editingAddress) {
      setIsDefault(editingAddress.isDefault);
    }
  }, [editingAddress]);
  const convertedProvinces = provinces == null ? void 0 : provinces.map(({ name, code }) => ({
    text: name,
    value: code
  }));
  const convertedDistricts = districts == null ? void 0 : districts.map(({ name, code }) => ({
    text: name,
    value: code
  }));
  const convertedWards = wards == null ? void 0 : wards.map(({ name, code }) => ({
    text: name,
    value: code
  }));
  const onClickSuggest = async (placeId) => {
    var _a, _b;
    const items = await getPlaceDetails(placeId);
    if (!items || !Array.isArray(items) || !items.length) {
      return;
    }
    const item = items == null ? void 0 : items[0];
    const address = ((_b = (_a = item.fullAddress.split(",")) == null ? void 0 : _a.splice(0, item.fullAddress.split(",").length - COUNT_STRING_WITHOUT_STREET_ADDRESS)) == null ? void 0 : _b.join(",")) || item.fullAddress || "";
    setOpenListSuggestion == null ? void 0 : setOpenListSuggestion(false);
    setPlace({ lat: item.lat, long: item.long });
    const newValue = __spreadValues(__spreadValues({
      provinceCode: item.provinceCode || void 0
    }, item.districtCode ? { districtCode: item.districtCode } : {}), item.wardCode ? { wardCode: item.wardCode } : {});
    form.setFieldsValue(__spreadProps(__spreadValues({}, newValue), {
      address
    }));
    if (!!item.provinceCode && !!item.districtCode && !!item.wardCode) {
      setLocation({
        provinceCode: item.provinceCode,
        districtCode: item.districtCode,
        wardCode: item.wardCode
      });
    }
  };
  const resetPosition = () => {
    setPlace({ lat: void 0, long: void 0 });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, message.content && /* @__PURE__ */ React.createElement(Caption, {
    color: message.success ? "success500" : "error500"
  }, message.content), /* @__PURE__ */ React.createElement(Form, {
    layout: "vertical",
    form,
    initialValues: initialFormValues
  }, () => {
    const defaultChildren = /* @__PURE__ */ React.createElement(React.Fragment, null, !hideFormTitle && /* @__PURE__ */ React.createElement(Title, {
      level: 2
    }, t("Th\xF4ng tin ng\u01B0\u1EDDi nh\u1EADn h\xE0ng")), /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("H\u1ECD t\xEAn"),
      name: "name",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        },
        {
          pattern: /[^!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/g,
          message: t("${label} kh\xF4ng \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      placeholder: t("Vui l\xF2ng nh\u1EADp t\xEAn ng\u01B0\u1EDDi nh\u1EADn")
    })), /* @__PURE__ */ React.createElement(Row, {
      justify: "space-between"
    }, /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"),
      name: "telephone",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        },
        {
          pattern: /((\+84|84|0)+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/g,
          message: t("${label} kh\xF4ng \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      placeholder: t("Nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i")
    }))), /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: "Email",
      name: "email",
      rules: [
        {
          required: requireEmail,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        },
        {
          pattern: PATTERN_VALIDATION.email,
          message: t("${label} kh\xF4ng \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      placeholder: t("Nh\u1EADp email c\u1EE7a b\u1EA1n")
    })))), /* @__PURE__ */ React.createElement(Divider, {
      color: "divider"
    }), /* @__PURE__ */ React.createElement(Title, {
      level: 2
    }, t("\u0110\u1ECBa ch\u1EC9 nh\u1EADn h\xE0ng")), /* @__PURE__ */ React.createElement(Row, {
      justify: "space-between"
    }, /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("T\u1EC9nh/Th\xE0nh ph\u1ED1"),
      trigger: "selectValue",
      name: "provinceCode",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        }
      ],
      validateTrigger: "selectValue"
    }, /* @__PURE__ */ React.createElement(Select, {
      options: convertedProvinces,
      value: province == null ? void 0 : province.code,
      maxPerView: 5,
      selectValue: (value) => {
        const location = provinces.find((prov) => prov.code === value);
        if (location) {
          onProvinceChanged(location);
          customOnProvinceChanged == null ? void 0 : customOnProvinceChanged(location);
          resetPosition();
        }
      },
      onDelete: () => {
        form.setFieldsValue({
          provinceCode: "",
          districtCode: "",
          wardCode: ""
        });
        onProvinceChanged(null);
        customOnProvinceChanged == null ? void 0 : customOnProvinceChanged(null);
        resetPosition();
      }
    }))), /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("Qu\u1EADn/Huy\u1EC7n"),
      trigger: "selectValue",
      name: "districtCode",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        }
      ],
      validateTrigger: "selectValue"
    }, /* @__PURE__ */ React.createElement(Select, {
      options: convertedDistricts,
      value: district == null ? void 0 : district.code,
      maxPerView: 5,
      selectValue: (value) => {
        const location = districts.find((dist) => dist.code === value);
        if (location) {
          onDistrictChanged(location);
          customOnDistrictChanged == null ? void 0 : customOnDistrictChanged(location);
          resetPosition();
        }
      },
      onDelete: () => {
        form.setFieldsValue({
          districtCode: "",
          wardCode: ""
        });
        onDistrictChanged(null);
        customOnDistrictChanged == null ? void 0 : customOnDistrictChanged(null);
        resetPosition();
      }
    })))), /* @__PURE__ */ React.createElement(Row, {
      justify: "space-between",
      marginBottom: "s8"
    }, /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("Ph\u01B0\u1EDDng/X\xE3"),
      trigger: "selectValue",
      name: "wardCode",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        }
      ],
      validateTrigger: "selectValue"
    }, /* @__PURE__ */ React.createElement(Select, {
      options: convertedWards,
      value: ward == null ? void 0 : ward.code,
      maxPerView: 5,
      selectValue: (value) => {
        const location = wards.find((ward2) => ward2.code === value);
        if (location) {
          onWardChanged(location);
          customOnWardChanged == null ? void 0 : customOnWardChanged(location);
          resetPosition();
        }
      },
      onDelete: () => {
        form.setFieldsValue({
          wardCode: ""
        });
        customOnWardChanged == null ? void 0 : customOnWardChanged(null);
        resetPosition();
      }
    }))), /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("\u0110\u1ECBa ch\u1EC9 c\u1EE5 th\u1EC3"),
      name: "address",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      disabled: (!(province == null ? void 0 : province.code) || !(district == null ? void 0 : district.code) || !(ward == null ? void 0 : ward.code)) && isDisableFullAddressWhenNotOtherInfo,
      placeholder: t("S\u1ED1 nh\xE0, ng\xF5, t\xEAn \u0111\u01B0\u1EDDng..."),
      onChange: (text) => {
        onChangeAddress == null ? void 0 : onChangeAddress(text);
        resetPosition();
      }
    })))), !!dataSuggestion && !!openListSuggestion && (!!dataSuggestion.length || isLoadingSuggest) && /* @__PURE__ */ React.createElement(SuggestWrapper, null, isLoadingSuggest ? /* @__PURE__ */ React.createElement(Flex, {
      justify: "center",
      align: "center"
    }, /* @__PURE__ */ React.createElement(Spinner, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, {
      style: { textAlign: "left" }
    }, t("G\u1EE3i \xFD")), dataSuggestion.map((item) => {
      return /* @__PURE__ */ React.createElement(ItemSuggestion, {
        key: item.fullAddress,
        onClick: () => onClickSuggest == null ? void 0 : onClickSuggest(item.placeId)
      }, /* @__PURE__ */ React.createElement(LocationOutlined, null), /* @__PURE__ */ React.createElement(Text, {
        style: { textAlign: "left", marginLeft: 8 }
      }, item.fullAddress));
    }))), !(editingAddress == null ? void 0 : editingAddress.isDefault) && !allowAddDefaultAdress && /* @__PURE__ */ React.createElement(Row, {
      justify: defaultCheckboxJustify
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      name: "isDefault",
      rules: [],
      trigger: "onChange"
    }, /* @__PURE__ */ React.createElement(Checkbox, {
      checked: isDefault,
      onChange: () => setIsDefault(!isDefault)
    }, t("\u0110\u1EB7t l\xE0m m\u1EB7c \u0111\u1ECBnh")))));
    return typeof children === "function" ? children(defaultChildren) : defaultChildren;
  }), onCloseForm && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    style: { marginTop: 40 }
  }), /* @__PURE__ */ React.createElement(BottomAction, {
    justify: "end",
    backgroundColor: "white"
  }, /* @__PURE__ */ React.createElement(Button, {
    variant: "secondary",
    onClick: () => onCloseForm(false)
  }, t("H\u1EE7y b\u1ECF")), /* @__PURE__ */ React.createElement(Button, {
    disabled: disableSubmit,
    variant: "primary",
    marginLeft: "s8",
    onClick: async () => {
      setDisableSubmit(true);
      try {
        await form.validateFields();
        const res = await submitForm(form.getFieldsValue());
        onCloseForm(true, res);
      } catch (e) {
        setDisableSubmit(false);
      }
    }
  }, t("L\u01B0u \u0111\u1ECBa ch\u1EC9")))));
};
UpsertAddressForm.Item = Form.Item;
const BottomAction = styled(Row)`
  position: fixed;
  bottom: 24px;
  left: 0;
  right: 24px;
  padding-top: 12px;
`;
const SuggestWrapper = styled.div`
  background-color: #fafafa;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 15px;
  max-height: 200px;
  overflow-y: scroll;
`;
const ItemSuggestion = styled.div`
  padding: 8px 10px;
  cursor: pointer;
`;
const Text = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #434657;
`;
const Spinner = styled.div(() => `
  border: 3px solid #BBDEFB;
  border-top-color: #2196F3;
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  margin: 0 0.5rem;
  animation: spin 1s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`);

export { ItemSuggestion, Spinner, SuggestWrapper, UpsertAddressForm };
